import { patchFeatureFlag } from '@gonfalon/openapi/operations/patchFeatureFlag';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createMutationHook } from '../internal/createMutationHook';
import { createQueryOptions } from '../internal/createQueryOptions';
import { getFeatureFlagQuery, getFeatureFlagsQuery } from '../queries/flags';

function patchSemantically(
  input: Parameters<typeof patchFeatureFlag>[0],
  options: Parameters<typeof patchFeatureFlag>[1] = {},
) {
  return patchFeatureFlag(input, {
    ...options,
    headers: {
      ...options.headers,
      'Content-Type': 'application/json; domain-model=launchdarkly.semanticpatch',
    },
  });
}

export const useUpdateFlagSemantically = createMutationHook(patchSemantically, {
  onSuccess: async (response, { projectKey }) => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({ queryKey: getFeatureFlagsQuery.partialQueryKey() });
    queryClient.setQueryData(getFeatureFlagQuery({ projectKey, featureFlagKey: response.key }).queryKey, response);
  },
});

export const patchSemanticallyQuery = createQueryOptions(patchSemantically);
